module.exports = __webpack_public_path__ + "static/media/micuenta_n_pedido.d3adf458.png";